// removed by extract-text-webpack-plugin
module.exports = {"logistica_popover":"logistica__logistica_popover___AQKbX","logistica_container":"logistica__logistica_container___3NZEK","formulario":"logistica__formulario___iddGY","logistica_mensaje":"logistica__logistica_mensaje___2XNdc","nombre":"logistica__nombre___2VShv","boton":"logistica__boton___1UIey","textoConTooltip":"logistica__textoConTooltip___16kwB","mytextarea":"logistica__mytextarea___13KEY","editar":"logistica__editar___3Drb-","input_logistica_editable":"logistica__input_logistica_editable___1jXPV","input_logistica_pointer":"logistica__input_logistica_pointer___3I7jQ"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/inventarios/programacion-semanal/logistica.css
// module id = 726
// module chunks = 0